import type { ToolCallStatus } from "@fwf/fwfa-design-system/react";

const ASK_USER_PATTERN = /^(asking user:|ask user:)\s*/i;
const HTTP_SERVER_PATTERN = /\bpython(?:3)?\s+-m\s+http\.server(?:\s+\d+)?\b/i;
const START_COMMAND_PATTERN = /\b(?:npm|pnpm|yarn|bun)\s+run\s+(dev|start)\b/i;
const PREVIEW_COMMAND_PATTERN = /\b(?:npm|pnpm|yarn|bun)\s+run\s+preview\b/i;
const BUILD_COMMAND_PATTERN = /\b(?:npm|pnpm|yarn|bun)\s+run\s+build\b/i;

// The app's tool status in the DS's vocabulary. An absent status means the call
// is over and nothing went wrong, which is how the hand-rolled rows read it: the
// spinner was the running branch and everything else fell through to the tick.
export function dsToolStatus(status?: "running" | "completed" | "error"): ToolCallStatus {
  if (status === "running") return "running";
  if (status === "error") return "error";
  return "success";
}

export function humanizeToolName(rawToolName: string): string {
  const trimmed = rawToolName.trim();
  if (!trimmed) return "Working in your project";

  const name = trimmed.replace(ASK_USER_PATTERN, "").trim();
  if (!name) return "Need your input";

  if (/^functions\.exec_command$/i.test(name)) return "Working in your project";
  if (/^openInEditor$/i.test(name)) return "Opening the file";
  if (HTTP_SERVER_PATTERN.test(name)) return "Opening a quick preview";
  if (BUILD_COMMAND_PATTERN.test(name)) return "Building the project";
  if (PREVIEW_COMMAND_PATTERN.test(name)) return "Getting the preview ready";
  if (START_COMMAND_PATTERN.test(name)) return "Starting the app";

  if (/\b(?:localhost|127\.0\.0\.1)\b/i.test(name)) {
    return "Checking the local app";
  }

  if (/\bpreview\b/i.test(name) && /\b(?:run|start|serve|server|port)\b/i.test(name)) {
    return "Getting the preview ready";
  }

  if (/^run\s+/i.test(name)) {
    return humanizeToolName(name.replace(/^run\s+/i, ""));
  }

  return name;
}
